export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40081aa7dacf231d829bcfba0ae83fd22318fbd03f&name=revalidateCommunity!'